import { Form, message } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import DrawerBilling from "../DrawerBilling";

import * as REDUX_ACTION from "../../../../services/redux/actions";

export const DrawerManageReceipt = (props) => {
  const { isOpen, setIsOpen, data, type, user } = props;

  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const [fileList, setFileList] = useState([]);
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue(data);
    }
  }, [isOpen]);

  useEffect(() => {
    if (fileList.length > 0) {
      if (type === "update" && edit) {
        const role = user?.uroleid;
        const fileListFilter = fileList.map(({ uid, status, ...rest }) => rest);
        const dataItems = {
          ...data,
          receipt: fileListFilter,
        };

        delete dataItems?.key;
        delete dataItems?.refid;
        delete dataItems?.company_name;

        const formData = {
          billid: dataItems?.billid,
          updatedBy: user?.memid,
          items: dataItems,
        };

        // messageApi.open({
        //   type: "loading",
        //   content: "Updating attachment receipt...",
        //   duration: 0,
        // });

        // dispatch(
        //   REDUX_ACTION.v1_billing.update_billing_request(formData, role, () => {
        //     messageApi.destroy();
        //   })
        // );
        setEdit(false);
      }
    }
  }, [fileList, type, data, user, form, edit, dispatch]);

  return (
    <>
    {contextHolder}
      <DrawerBilling
        form={form}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        data={data}
        type={type}
        user={user}
        fileList={fileList}
        setFileList={setFileList}
        edit={edit}
        setEdit={setEdit}
      />
    </>
  );
};
